import { connect } from 'react-redux';
import OrderDashboardTimelineStatusType from '../components/OrderDashboardPages/pages/OrderDashboardTimelineStatusType';
import { getUser } from '../redux/actions/AccountSetting';
import { DashboardTimelineType } from '../constants/ComponentTypes';
import { getCurrentPersonStatus } from '../redux/actions/CurrentPersonStatus';
import { push } from 'react-router-redux';

const mapStateToProps = (state) => ({
  user: state.accountSetting.user,
  list: state.currentPersonStatus.currentStatusList,
  isLoading: state.currentPersonStatus.isLoadingCurrentPersonStatus,
  pageInfo: state.currentPersonStatus.pageInfoCurrentPersonStatus,
  type: (() => {
    const path = state.router.location.pathname.replace("/order-dashboard", "");
    const target = Object.values(DashboardTimelineType).find(item => item.path === path);
    return target ? target.value : DashboardTimelineType.APPROACH.value;
  })(),
})

const mapDispatchToProps = dispatch => ({
  getCurrentPersonStatus(data) {
    dispatch(getCurrentPersonStatus(data));
  },

  getUserInfo() {
    dispatch(getUser());
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderDashboardTimelineStatusType);



// WEBPACK FOOTER //
// ./src/containers/OrderDashboardTimelineStatusType.js